export const MEDICAL_INSURENCE_PARTICULAR = {
    codigo: 1,
    nome: "Particular"
}